import { render, staticRenderFns } from "./items-by-order.vue?vue&type=template&id=05cb587e&"
import script from "./items-by-order.vue?vue&type=script&lang=js&"
export * from "./items-by-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports